import React, {forwardRef} from 'react'
import PropTypes from 'prop-types'
import TextareaAutosize from 'react-textarea-autosize'
import {useIncrementingId} from '#hooks/useIncrementingId'

const TextareaResize = forwardRef(
  (
    {
      dataType,
      defaultValue,
      disabled,
      labelText,
      labelPosition,
      maxRows,
      minRows,
      name,
      onBlurHandle,
      onChangeHandle,
      placeholder,
      value,
      maxLength,
      autoFocus,
    },
    ref,
  ) => {
    const id = useIncrementingId()
    return (
      <div className="textareaAutosize textarea">
        <label htmlFor={id}>
          {(labelPosition === 'left' || labelPosition === undefined) && labelText}
          <TextareaAutosize
            id={id}
            data-type={dataType}
            defaultValue={defaultValue}
            disabled={disabled}
            name={name}
            maxLength={maxLength}
            maxRows={maxRows}
            rows={minRows}
            onChange={onChangeHandle ? elem => onChangeHandle(elem) : undefined}
            onBlur={onBlurHandle ? elem => onBlurHandle(elem) : undefined}
            placeholder={disabled ? '' : placeholder}
            value={value}
            autoFocus={autoFocus}
            ref={ref}
          />
          {labelPosition === 'right' && labelText}
        </label>
      </div>
    )
  },
)

TextareaResize.propTypes = {
  dataType: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  labelText: PropTypes.string,
  labelPosition: PropTypes.string,
  maxRows: PropTypes.number,
  minRows: PropTypes.number,
  name: PropTypes.string,
  onBlurHandle: PropTypes.func,
  onChangeHandle: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  autoFocus: PropTypes.bool,
}

export default TextareaResize
